export * from './types';
export {RxAxios} from './rx-axios';



// WEBPACK FOOTER //
// ./src/shared/index.ts